import { useCallback, useContext } from 'react';
import ScorecardsContext from '../../../../../../contexts/ScorecardsContext';
import metricTypeCheckers from '../../../../../../types/metricTypeCheckers';
import usesFieldInPlates from './usesFieldInPlates';
import { isKpiRow } from '../../../../../../hooks/kpiTypeCheckers';
import MetricOptionsContext from '../../../../../../contexts/MetricOptionsContext';
import _ from 'lodash';

const useGetFieldScorecardUsage = () => {
  const { scorecards } = useContext(ScorecardsContext);
  const { metricOptionsLookup } = useContext(MetricOptionsContext);

  const getFieldScorecardUsage = useCallback(
    (field: string, dataset: string) => {
      const matches = scorecards.filter((scorecard) => {
        return scorecard.kpis.filter(isKpiRow).some((kpi) => {
          // Field used in drillDown or scope plates
          if (
            usesFieldInPlates(kpi.drillDowns, field, dataset) ||
            usesFieldInPlates(kpi.scopeDrillDowns, field, dataset)
          ) {
            return true;
          }

          // Field used as queryDateField for a KPI on this dataset
          if (kpi.queryDateField !== field) return false;

          const metric = metricOptionsLookup[kpi.metricId];
          if (!metric || metricTypeCheckers.isSpecialMetric(metric))
            return false;

          if (metricTypeCheckers.isNormalMetric(metric)) {
            return metric.dataType === dataset;
          }

          // compound metric
          const subMetrics = metric.metricIds
            .map((mid) => metricOptionsLookup[mid])
            .filter(Boolean)
            .filter(metricTypeCheckers.isNormalMetric);

          return subMetrics.some((m) => m.dataType === dataset);
        });
      });

      return _.uniqBy(matches, 'id');
    },
    [metricOptionsLookup, scorecards],
  );

  return getFieldScorecardUsage;
};

export default useGetFieldScorecardUsage;
